import styled from "styled-components";

const StyledNewsletter = styled.div`
  margin-top: 34px;
  // flex: 1;
  padding: 0 20px;
  @media (max-width: 940px) {
    display: flex;
    flex-flow: column nowrap;
  }
  @media (min-width: 768px) {
    width: 100%;
    max-width: 860px;
    margin: 80px auto 0 auto;
    box-sizing: border-box;
  }
  ${(props) => props.customstyles}
`;

const StyledWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  // @media (max-width: 768px) {
  //   flex-flow: column nowrap;
  // }
  ${({ isMobile }) => (isMobile ? "flex-flow: column nowrap;" : "")};
`;

const StyledInputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: ${({ fullWidth }) => (fullWidth ? "1" : "0 0 200px")};
  align-items: flex-start;
  padding-right: 32px;
  margin-bottom: 30px;
  &:last-of-type {
    padding-right: 0px;
  }
  box-sizing: border-box;
  // @media (max-width: 768px) {
  //   flex: 0; padding: 0; width: 100%;
  // }
  ${({ isMobile }) => (isMobile ? "flex: 0; padding: 0; width: 100%;" : "")};
`;

const StyledNewsletterHeading = styled.div`
  font-size: 24px;
  line-height: 1em;
  text-align: center;
  letter-spacing: 0.2px;

  color: #fff;
  font-family: "FuturaPT-Medium";
  margin-bottom: ${({ noMargin }) => (!noMargin ? "30px" : "0")};

  @media (min-width: 768px) {
    display: block;
    font-size: 30px;
    margin-bottom: 60px;
    line-height: 1.5em;
  }

  ${(props) => props.customstyles}
`;

const StyledInput = styled.input`
  // flex: 1;
  font-family: "FuturaPT-Medium";
  border: none;
  border-bottom: 1px solid #999;
  outline: none;
  background: transparent;
  height: 30px;
  // margin: 0 auto 30px auto;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 22px;
  color: #fff;
  display: block;
  width: 100%;
  ::placeholder {
    color: #999;
  }
  @media (min-width: 892px) {
    /* margin-right: 32px; */
    display: inline-block;
  }
`;

const StyledErrorMsg = styled.span`
  && {
    font-size: 14px;
    color: red;
    line-height: 14px;
    font-family: FuturaPT-Medium;
    text-align: center;
    height: 14px;
    padding-top: 10px;
  }
`;

const StyledResponse = styled.div`
  padding: 20px 40px;
  color: #ffffff;
  font-family: "Ogg-Regular";
  font-size: 28px;
  line-height: 30px;
  text-align: center;
  // flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  max-width: 250px;
  margin: 0 auto;
`;

const HiddenLabel = styled.div`
  border: 0;
  clip: rect(0 0 0 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
`;

export {
  StyledNewsletter,
  StyledWrapper,
  StyledInputWrapper,
  StyledInput,
  StyledNewsletterHeading,
  StyledResponse,
  StyledErrorMsg,
  HiddenLabel,
};
